import { render, staticRenderFns } from "./IntegralOrder.vue?vue&type=template&id=905b9922&scoped=true"
import script from "./IntegralOrder.vue?vue&type=script&lang=js"
export * from "./IntegralOrder.vue?vue&type=script&lang=js"
import style0 from "./IntegralOrder.vue?vue&type=style&index=0&id=905b9922&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905b9922",
  null
  
)

export default component.exports